var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._b({attrs:{"persistent":"","fullscreen":_vm.$vuetify.breakpoint.smAndDown,"max-width":"1153px"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},'v-dialog',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }